<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col
              v-if="$utilFront.withPermission($prm.ADD_MODALITY)"
              cols="12"
              md="4"
              xl="2"
              sm="12"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    block
                    @click="changeAction(2)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-plus</v-icon> Nueva modalidad
                  </v-btn>
                </template>
                <span>Agregar modalidad</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.UPDATE_MODALITY)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="checkModality(item)">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Editar información</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.DELETE_MODALITY)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="openDialogDelete(item)">
                    <v-icon color="error" v-bind="attrs" v-on="on">
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-row class="py-3" align="center" justify="center">
            <v-col cols="6">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <export-import-btn
                    texto="Importar modalidades"
                    icono="import"
                    color="light-blue darken-2"
                    @accion="askFileImport()"
                  />
                </v-col>
                <v-col class="text-center">
                  <export-import-btn
                    texto="Exportar modalidades"
                    icono="export"
                    color="green darken-1"
                    @accion="downloadTempletate()"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <encabezado
        :elementos="encabezado"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de modalidad"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="100"
                      :error-messages="errors"
                      label="Nombre de Modalidad"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Especialidad"
                    rules="required"
                  >
                    <v-autocomplete
                      v-if="showAction(2)"
                      v-model="dataModal.speciality"
                      label="Especialidad"
                      :items="listSpeciality"
                      :item-text="listSpeciality.text"
                      :item-value="listSpeciality.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="showAction(3)"
                      v-model="dataModal.speciality.idSpeciality"
                      label="Especialidad"
                      :items="listSpeciality"
                      :item-text="listSpeciality.text"
                      :item-value="listSpeciality.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Acrónimo de modalidad"
                    rules="required|max:20"
                  >
                    <v-text-field
                      v-model="dataModal.acronym"
                      :counter="20"
                      :error-messages="errors"
                      label="Acrónimo de modalidad"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            {{ dialogs.title }}
          </v-card-title>
          <v-card-text>{{ dialogs.text }} </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                dialog = false;
                changeStatus();
              "
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="importDialog" max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Importar modalidades
          </v-card-title>
          <v-card-text>
            <v-file-input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              label="Cargar archivo"
              placeholder="Seleccione un archivo"
              v-model="fileXLSX"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="importDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="importXLSX()"
              :disabled="!fileXLSX"
            >
              Cargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateModal" max-width="450">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col class="text-center">
                <h1>Modalidades</h1>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex flex-column" justify="center" align="center">
              <v-col
                class="text-center font-weight-bold title"
                :class="results.done ? 'success--text' : 'error--text'"
              >
                {{
                  results.done
                    ? "Registros cargados correctamente"
                    : "Sucedio un error al cargar los registros"
                }}
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="success" left>mdi-check-circle</v-icon>Nuevos:
                  {{ results.news }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="warning" left>mdi-circle-edit-outline</v-icon
                  >Modificados: {{ results.updates }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="error" left>mdi-alert-circle</v-icon>Errores:
                  <ul>
                    <li
                      v-for="(error, index) in results.errors"
                      :key="index"
                      class="my-3"
                    >
                      <v-icon color="warning" left>mdi-exclamation</v-icon>Error
                      {{ index + 1 }}: {{ error }}
                    </li>
                  </ul>
                </h2>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center">
              <v-btn text color="error" @click="updateModal = !updateModal"
                >Cerrar</v-btn
              >
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDelete" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea eliminar la modalidad?
          </v-card-title>
          <v-card-text>
            <strong>Modalidad: </strong> {{ model.name }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialogDelete()">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="deleteModality()"
              :disabled="sending"
            >
              Sí, eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import Loader from "@/components/Loader.vue";
import { ModaltyRequest } from "@/core/request";
import { SpecialityRequest, ReportPDFRequest } from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import AutoLogout from "../../components/AutoLogout.vue";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Modalidades",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    Loader,
  },
  data() {
    return {
      dialog: false,
      importDialog: false,
      updateModal: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: { icono: "mdi-view-module", texto: "Modalidades" },
      list: [],
      listSpeciality: [],
      sending: false,
      dialogs: {
        title: "¿Desea cambiar el estatus de ésta modalidad?",
        text:
          "La modalidad será habilidata / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
      },
      headers: [
        { text: "ID Modalidad", value: "idModality" },
        { text: "Nombre", value: "name" },
        { text: "Especialidad", value: "speciality.name" },
        { text: "Acrónimo", value: "acronym" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Modalidad",
        tooltip: "Agregar Modalidad",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar modalidad",
      service: ModaltyRequest,
      service: SpecialityRequest,
      fileXLSX: null,
      results: {},
      dialogDelete: false,
      model: {},
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
    this.listAllSpeciality();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-view-module",
            texto: "Modalidades",
          };
          this.dialogs = {
            title: "¿Desea cambiar el estatus de ésta modalidad?",
            text:
              "La modalidad será habilidata / inhabilitada de inmediato y podría afectar a los registros que dependan de ella",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-view-module",
            texto: "Registrar modalidad",
          };
          this.dialogs = {
            title: "¿Desea registrar ésta modalidad?",
            text:
              "La modalidad será registrada de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar modalidad";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-view-module",
            texto: "Editar modalidad",
          };
          this.dialogs = {
            title: "¿Desea modificar ésta modalidad?",
            text:
              "La modalidad será modificada de inmediato y podría afectar a los registros que dependan de ella",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar modalidad";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-view-module",
            texto: "Modalidades",
          };
          break;
      }
    },
    doAction() {
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },
    listAllSpeciality() {
      SpecialityRequest.allSpeciality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listSpeciality = res.data.data.map((speciality) => {
            return {
              value: speciality.idSpeciality,
              text: speciality.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    listAll() {
      ModaltyRequest.allModality().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((modality) => {
            return {
              idModality: modality.idModality,
              name: modality.name,
              speciality: modality.speciality || "--- Sin información ---",
              acronym: modality.acronym,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if (!this.sending) {
        let postData = {
          idModality: this.dataModal.idModality,
          name: this.dataModal.name,
          acronym: this.dataModal.acronym,
          speciality: {
            idSpeciality: this.dataModal.speciality,
          },
        };
        this.sending = true;
        ModaltyRequest.addModality(postData)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Modalidad registrada correctamente",
                "SUCCESS"
              );
              this.listAll();
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al registrar la modalidad",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    update() {
      if (!this.sending) {
        let postData = {
          idModality: this.dataModal.idModality,
          name: this.dataModal.name,
          acronym: this.dataModal.acronym,
          speciality: {
            idSpeciality: this.dataModal.speciality.idSpeciality,
          },
        };
        this.sending = true;
        ModaltyRequest.updateModality(postData)
          .then((res) => {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.$utilFront.notifications(
                "Modalidad modificada correctamente",
                "SUCCESS"
              );
              this.listAll();
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al modificar la modalidad",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    checkModality(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.changeAction(3);
    },
    askFileImport() {
      this.importDialog = !this.importDialog;
    },
    importXLSX() {
      this.importDialog = false;

      if (this.fileXLSX) {
        this.sending = true;
        let formData = new FormData();
        formData.append("file", this.fileXLSX);

        ReportPDFRequest.importTempletateModalities(formData)
          .then((res) => {
            res.data.text().then((texto) => {
              const { done, errors, news, updates } = JSON.parse(texto).data;
              this.results = JSON.parse(texto).data;

              if (done) {
                this.listAll();
                this.updateModal = true;
                this.fileXls = null;
              }
            });
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    downloadTempletate() {
      this.sending = true;
      ReportPDFRequest.downloadTempletateModalities()
        .then((response) => {
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );
          /* Simulo el click */
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Modalidades.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    openDialogDelete(item) {
      this.model = Object.assign(this.model, item);
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.model = Object.assign(this.model, {});
      this.dialogDelete = false;
    },
    deleteModality() {
      this.sending = true;
      let params = { idModality: this.model.idModality };
      ModaltyRequest.deleteModalty(params)
        .then((res) => {
          let { data, code, status } = res.data;
          // console.log(res);
          if (code == 200 && data == true) {
            this.closeDialogDelete();
            this.listAll();
            this.$utilFront.notifications("Modalidad eliminada.", "SUCCESS");
          } else {
            // let message;
            // if (data == {}){
            //   message = "El registro cuenta con dependencias"
            // } else {
            //   message = data
            // }
            this.$utilFront.notifications(
              "El registro cuenta con dependencias",
              "ERROR"
            );
          }
        })
        .catch(this.$utilFront.errorhttp)
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
